import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('Kooperation')

export default {
  label: 'Kooperation',
  route: 'kooperation',
  fields: [
    Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'),
    Filter.kumuliert(),
    Filter.Number('berichtsjahr', 'calendar-o'),
    Filter.ReferenceByMultiValueSearchRep('beteiligte', 'user', 'abstractPerson'),
    Filter.String('titelKooperation'),
    Filter.ReferenceBySearchRep('beteiligteOrganisationen', 'user', 'externeOrganisation')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/KooperationFilter.js